import React from 'react';
import { QrCode, Github, Twitter, Mail } from 'lucide-react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <QrCode className="h-8 w-8 text-green-400" />
              <span className="text-xl font-bold bg-gradient-to-r from-green-400 to-blue-400 bg-clip-text text-transparent">
                FreeQRCodeNow
              </span>
            </div>
            <p className="text-gray-400 mb-4 max-w-md">
              Create beautiful, customizable QR codes for free. Generate static and dynamic QR codes 
              with logo upload, analytics, and more. No registration required.
            </p>
            <div className="flex space-x-4">
              <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                <Github className="h-5 w-5" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="mailto:support@freeqrcodenow.com" className="text-gray-400 hover:text-white transition-colors">
                <Mail className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Features */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Features</h3>
            <ul className="space-y-2 text-gray-400">
              <li><a href="/generate" className="hover:text-green-400 transition-colors">Static QR Codes</a></li>
              <li><a href="/dynamic" className="hover:text-blue-400 transition-colors">Dynamic QR Codes</a></li>
              <li><a href="/generate" className="hover:text-green-400 transition-colors">Logo Upload</a></li>
              <li><a href="/generate" className="hover:text-blue-400 transition-colors">Custom Colors</a></li>
              <li><a href="/dashboard" className="hover:text-green-400 transition-colors">Analytics</a></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Support</h3>
            <ul className="space-y-2 text-gray-400">
              <li><a href="/help" className="hover:text-white transition-colors">Help Center</a></li>
              <li><a href="/api-docs" className="hover:text-white transition-colors">API Documentation</a></li>
              <li><a href="mailto:support@freeqrcodenow.com" className="hover:text-white transition-colors">Contact Us</a></li>
              <li><a href="/privacy" className="hover:text-white transition-colors">Privacy Policy</a></li>
              <li><a href="/terms" className="hover:text-white transition-colors">Terms of Service</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2024 FreeQRCodeNow. All rights reserved. Made with ❤️ for the community.</p>
        </div>
      </div>
    </footer>
  );
};



